import { render, staticRenderFns } from "./ConsultantRolesHistory.vue?vue&type=template&id=88b39062"
import script from "./ConsultantRolesHistory.vue?vue&type=script&lang=js"
export * from "./ConsultantRolesHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports